import { APICore } from './apiCore'

const api = new APICore()

function getOtherDataContacts (params) {
  const baseUrl = '/other-data-contacts'
  return api.get(baseUrl, params)
}

function getOtherDataContact (id) {
  const baseUrl = `/other-data-contacts/${id}`
  return api.get(baseUrl, {})
}

function addOtherDataContact (params) {
  const baseUrl = '/other-data-contacts'
  return api.create(baseUrl, params)
}

function updateOtherDataContact (params) {
  const baseUrl = '/other-data-contacts'
  return api.update(baseUrl, params)
}

function deleteOtherDataContact (params) {
  const baseUrl = '/other-data-contacts'
  return api.delete(baseUrl, params)
}

export { getOtherDataContacts, getOtherDataContact, addOtherDataContact, updateOtherDataContact, deleteOtherDataContact }
